import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "elections-wrapper col-lg-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "election-name-wrapper",
  class: "election-name",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "election-name" }, [
    /*#__PURE__*/_createElementVNode("h2", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "name-box" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "election-name-title" }, "Elected Officials")
      ])
    ])
  ])
], -1)
const _hoisted_5 = {
  id: "elections-page-instructions-wrapper",
  class: "section-wrapper"
}
const _hoisted_6 = { class: "section-wrapper-2" }
const _hoisted_7 = { class: "elected-titles" }
const _hoisted_8 = {
  id: "#elected-officials-table",
  class: "flat-table table",
  style: {"text-align":"center","min-width":"500px"}
}
const _hoisted_9 = { class: "title-heading" }
const _hoisted_10 = {
  class: "th",
  colspan: "3"
}
const _hoisted_11 = { class: "localize" }
const _hoisted_12 = { id: "elected-titles-list" }
const _hoisted_13 = { class: "table-top" }
const _hoisted_14 = { class: "table-top-left" }
const _hoisted_15 = { class: "localize" }
const _hoisted_16 = { class: "table-top-left" }
const _hoisted_17 = { class: "localize" }
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title-id", "onClick"]
const _hoisted_20 = { class: "table-left" }
const _hoisted_21 = {
  id: "titlesModal",
  class: "modal fade in",
  role: "dialog"
}
const _hoisted_22 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_23 = { class: "fancy-election-title" }
const _hoisted_24 = { id: "election-title-modal-table-placeholder" }
const _hoisted_25 = {
  key: 0,
  class: "flat-table table",
  style: {"width":"100%"}
}
const _hoisted_26 = { class: "title-heading" }
const _hoisted_27 = {
  colspan: "3",
  class: "th"
}
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "table-left election-rule-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_9, [
                      _createElementVNode("td", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("Elected Officials")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_12, [
                    _createElementVNode("tr", _hoisted_13, [
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("Title")), 1)
                      ]),
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("Title Holders")), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (title) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "table-middle",
                        key: `title${title.Id}`
                      }, [
                        _createElementVNode("td", {
                          class: "table-left",
                          "data-toggle": "tooltip",
                          "data-container": "body",
                          "data-placement": "left",
                          title: title.Name
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "title-name",
                            "title-id": title.Id,
                            onClick: ($event: any) => (_ctx.table = title),
                            "data-toggle": "modal",
                            "data-target": "#titlesModal"
                          }, _toDisplayString(title.Name), 9, _hoisted_19)
                        ], 8, _hoisted_18),
                        _createElementVNode("td", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(title.OccupantNames, (occupant) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `occupant${occupant}`
                            }, [
                              _createElementVNode("em", null, _toDisplayString(occupant), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_ctx.table.Id)
                ? (_openBlock(), _createElementBlock("table", _hoisted_25, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_26, [
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.table.Name), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.Table.slice(1), (rows) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `row${rows}`,
                          class: "table-middle"
                        }, [
                          _createElementVNode("td", {
                            class: "table-left election-rule",
                            "data-toggle": "tooltip",
                            "data-container": "body",
                            "data-placement": "left",
                            title: rows[1]
                          }, _toDisplayString(rows[0]), 9, _hoisted_28),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(rows[2]), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]))
  ], 64))
}